// extracted by mini-css-extract-plugin
module.exports = {"expanded":"ExpandableText_expanded__41N28","expandable_toggle_button":"ExpandableText_expandable_toggle_button__DbCfv"};